import {
  PortableText as PortableTextReact,
  PortableTextComponents,
  toPlainText,
} from "@portabletext/react";
import { PortableTextBlock } from "@portabletext/types";
import clsx from "clsx";
import { useMemo } from "react";
import Block from "./blocks/Block";
import * as styles from "./PortableText.css";
import { truncate } from "~/styles/functions";
import { Image } from "../elements/Image";
import { Paragraph } from "../elements/Paragraph";

export type IPortableText = PortableTextBlock | PortableTextBlock[];

export type TPortableText = {
  blocks?: IPortableText;
  className?: string;
  string?: boolean;
  truncateLength?: number;
};

export default function PortableText({
  blocks,
  className,
  string,
  truncateLength,
}: TPortableText) {
  if (!blocks) {
    return null;
  }

  if (string) {
    return toPlainText(blocks);
  }

  if (typeof blocks === "string") {
    return blocks;
  }

  if (Boolean(truncateLength)) {
    return truncate(toPlainText(blocks), truncateLength);
  }

  const components: PortableTextComponents = {
    list: {
      bullet: ({ children }) => (
        <ul className={styles.unOrderedList}>{children}</ul>
      ),
      number: ({ children }) => (
        <ol className={styles.orderedList}>{children}</ol>
      ),
    },
    block: Block,
    types: {
      image: ({ value }) => {
        return (
          <Image
            image={value}
            width={800}
            loading="eager"
            className={styles.image}
          />
        );
      },
    },
  };

  const portableText = useMemo(() => {
    return (
      <div className={clsx(className, styles.portabletext)}>
        <PortableTextReact value={blocks} components={components} />
      </div>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blocks]);

  return portableText;
}
